'use strict';

import angular from 'angular';


export default function($log, $http, $scope, toastr) {
	'ngInject';

	var vm = this;

	$http.get('/entity-data/filter_list/').then(function success(response) {
		if (!response.data.results.length) {
			vm.list = [];
			vm.savedList = null;
		} else {
			vm.list = response.data.results[0];
			vm.savedList = angular.copy(vm.list);
		}
	});

	vm.removeItem = function(idx) {
		vm.list.value.splice(idx, 1);
	}

	vm.revert = function() {
		vm.list = angular.copy(vm.savedList);
	}

	vm.save = function() {
		$http.post('/entity-data/filter_list/', {
			key: 'filter_list',
			value: vm.list.value,
		}).then(function success(response) {
			toastr.success('Alarm filters updated!');
			vm.list = response.data;
			vm.savedList = angular.copy(vm.list);
			vm.saving = false;
		}, function error(response) {
			alert('Error updating the filter list');
			vm.saving = false;
		});
		vm.saving = false;
	}
}
